<template>
  <div @keyup.enter.prevent="sendLink">
    <div class="title"> Восстановление пароля </div>

    <!-- Email input -->
    <form-group
      v-if="!linkSent"
      :validator="$v.corpEmail"
      :server-errors="serverError('corpEmail')"
    >
      <template slot-scope="{ attributes }">
        <UiInputText
          ref="corpEmail"
          v-model="corpEmail"
          placeholder="Корпоративный email"
          type="text"
          inputmode="email"
          autocapitalize="off"
          autocorrect="off"
          :class="attributes.class"
        >
        </UiInputText>
      </template>
    </form-group>

    <div v-if="!linkSent" class="footer">
      <UiButton
        :disabled="trySendLink"
        :class="['button', 'is-blue', { 'is-loading': trySendLink }]"
        @click="sendLink"
      >
        Отправить письмо
      </UiButton>

      <UiLink :to="{ name: 'login' }"> Страница входа </UiLink>
    </div>

    <div v-if="linkSent">
      <div>
        Письмо для установки нового пароля отправлено на почту. Перейдите по ссылке в письме, чтобы
        установить новый пароль.
      </div>

      <br />

      <UiLink :to="{ name: 'login' }"> Страница входа </UiLink>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

import validationHelpers from '@/mixins/validationHelpers.js'

import { AuthService } from '@/services/auth.service'

import UiButton from '@/components/UiButton.vue'
import UiInputText from '@/components/UiInputText.vue'
import UiLink from '@/components/UiLink.vue'

export default {
  components: {
    UiButton,
    UiInputText,
    UiLink,
  },
  mixins: [validationHelpers],
  data() {
    return {
      trySendLink: false,
      linkSent: false,
      corpEmail: '',
    }
  },
  validations: {
    corpEmail: {
      required,
      email,
    },
  },
  methods: {
    /**
     * Send reset password link to corp. email
     */
    async sendLink() {
      this.$v.$touch()
      this.clearFormServerErrors()

      if (this.$v.$invalid) return

      try {
        this.trySendLink = true

        await AuthService.sendLink({ email: this.corpEmail })

        this.linkSent = true
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error })

        this.formServerErrors = error.formServerErrors

        this.linkSent = false
      } finally {
        this.trySendLink = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  @include createFlex(flexbox, nowrap, row, space-between, center, center);
}
</style>
